export const claimReasonPopover = {
    data: () => ({
        claimReasons: {
            "IncorrectFreightCharge": {
                title: "Freight Claim",
                description: "This is to be used when claiming freight charge reimbursement only"
            },
            "CarrierClaimDamageLoss": {
                title: "Carrier Claim-Damage",
                description: "Part(s) damaged due to carrier negligence"
            },
            "DmgdPartDamagedBox": {
                title: "Not in Salable Condition",
                description: "Part is not salable due to damage (not carrier related) or other imperfection (rust, dirt, etc)"
            },
            "Shorted": {
                title: "Short Ship",
                description: "Shows on packing list as shipped but did not receive – no visible damage to shipping package"
            },
            "CarrierSrvcFailure": {
                title: "Carrier Service Failure",
                description: "NDA/2nd day air arrived late, shipment lost, packaged delivered to wrong addrress"
            },
            "WrongPartPickedOrShipped": {
                title: "Wrong Part Picked/Shipped",
                description: "Part number on part label is not the part number that was ordered"
            },
            "PackageError": {
                title: "Packaged Incorrect",
                description: "Box in part is not correct for the part number (does not match DealerNet picture)"
            },
            "McfTechOrBookWrong": {
                title: "Tech/CRM Ticket Quote Error",
                description: "Quoted incorrectly by Technical Support and/or CRM ticket"
            },
            "BadCross": {
                title: "Bad Cross/Literature Error",
                description: "Cross reference error.  Misprinted information in catalog or on DealerNet"
            },
            "OverShipped": {
                title: "Overship",
                description: "Extra parts received"
            },
            "IncompletePart": {
                title: "Incomplete Part",
                description: "Part is missing necessary components"
            },
            "CancelledPartReceived": {
                title: "Cancelled Part Received",
                description: "Order was cancelled, parts shipped/received"
            },
            "WrongFreightOrShipVia": {
                title: "Wrong Freight Or Ship Via",
                description: "Shipped using wrong carrier or terms (NDA, ground, etc.)"
            }
        }
    }),
    methods: {
        getClaimReasonDescription(key) {
            return this.claimReasons[key].description;
        }
    },
    computed: {        
        claimReasonHtml() {
            let retHtml = "<div class=\"container claimReasonContainer\">";
            let count = 0;
            Object.keys(this.claimReasons).forEach(function(key) {                
                let segment = `<div class="col-md-6">
                                <label>
                                    <strong>` + this.claimReasons[key].title + `</strong>
                                </label>
                                <div>
                                    ` + this.claimReasons[key].description + `
                                </div>
                            </div>`;
                if (count++ % 2 === 0) {
                    if ( count > 1 ) 
                    {
                        retHtml += "</div>"
                    }
                    retHtml += "<div class=\"row\">" + segment;
                } else {
                    retHtml += segment;
                }
            }, this);
            retHtml += "</div>"            
            return retHtml;
        }
    }
}